<!-- eslint-disable vuejs-accessibility/anchor-has-content -->
<template>
  <div
    v-if="signpost"
    :class="$blockClass(blockClass, 'signpost')"
  >
    <div
      v-if="!signpost.product && !signpost.product2 && !signpost.product3"
      class="navbar-signpost-images"
      :class="{
        'navbar-signpost-images--single': signpost.mediaCount === 1,
        'navbar-signpost-images--double': signpost.mediaCount === 2
      }"
      :style="signpost.overlay_text ? {} : { 'margin-block-start': '16px' }"
    >
      <div
        v-for="idx of imageIndices"
        :key="idx"
        :class="`signpost-image${idx}`"
      >
        <a
          v-if="signpost[`link${idx === 1 ? '' : idx}`]"
          :class="$blockClass(blockClass, 'signpost-link')"
          :href="
            !signpost[`video${idx === 1 ? '' : idx}`]
              ? signpost[`link${idx === 1 ? '' : idx}`]
              : null
          "
          :tabindex="isTabbable ? 0 : -1"
        >
          <template v-if="signpost[`video${idx === 1 ? '' : idx}`]">
            <video-player
              class="signpost-video"
              :video="getVideoObject(idx)"
              :icon-color="signpost[`videoPlayerIconColor${idx === 1 ? '' : idx}`] || 'white'"
              is-autoplay
              :display-overlay="false"
              :cta-url="false"
              :use-overlay-button="false"
              width="260"
              height="215"
            />
          </template>
          <template v-else>
            <responsive-image
              class="responsive-image"
              :image="signpost[`image${idx === 1 ? '' : idx}`]"
              min-max="215-260"
              :ratio="false"
            />
          </template>
          <div
            v-if="signpost.overlay_text"
            class="text-div signpost-overlay"
            :class="[
              getOverlayPositionClass(idx),
              getButtonPositionClass(idx),
              signpost[`video${idx === 1 ? '' : idx}`] &&
                getOverlayPositionClass(idx) === 'signpost-overlay--bottom-left'
                ? 'signpost-overlay--has-video'
                : ''
            ]"
          >
            <!-- eslint-disable-next-line vuejs-accessibility/no-static-element-interactions -->
            <p
              class="text-body-m-regular signpost-image-text"
              :style="{
                color: hovered[idx] === 'p'
                  ? signpost[`image${idx === 1 ? '' : idx}_text_hover_color`]
                  : signpost[`image${idx === 1 ? '' : idx}_text_color`]
              }"
              @mouseenter="hovered[idx] = 'p'"
              @mouseleave="hovered[idx] = null"
              @focus="hovered[idx] = 'p'"
              @blur="hovered[idx] = null"
            >{{ signpost[`image${idx === 1 ? '' : idx}_text`] }}</p>
            <a
              :class="`${$blockClass(blockClass, 'signpost-cta')}
               cta-button signpost-cta-button`"
              :href="signpost[`cta_link${idx === 1 ? '' : idx}`]"
              :style="{
                color: hovered[idx] === 'a'
                  ? signpost[`cta_button${idx === 1 ? '' : idx}_hover_color`]
                  : signpost[`cta_button${idx === 1 ? '' : idx}_color`]
              }"
              tabindex="0"
              @mouseenter="hovered[idx] = 'a'"
              @mouseleave="hovered[idx] = null"
              @focus="hovered[idx] = 'a'"
              @blur="hovered[idx] = null"
            >{{ signpost[`cta_button${idx === 1 ? '' : idx}_name`] }}</a>
          </div>
          <div
            v-else
            class="text-div"
            :class="getButtonPositionClass(idx)"
          >
            <!-- eslint-disable-next-line vuejs-accessibility/no-static-element-interactions -->
            <p
              class="text-body-m-regular signpost-image-text"
              :style="{
                color: hovered[idx] === 'p'
                  ? signpost[`image${idx === 1 ? '' : idx}_text_hover_color`]
                  : signpost[`image${idx === 1 ? '' : idx}_text_color`]
              }"
              @mouseenter="hovered[idx] = 'p'"
              @mouseleave="hovered[idx] = null"
              @focus="hovered[idx] = 'p'"
              @blur="hovered[idx] = null"
            >{{ signpost[`image${idx === 1 ? '' : idx}_text`] }}</p>
            <a
              :class="`${$blockClass(blockClass, 'signpost-cta')}
               cta-button signpost-cta-button`"
              :href="signpost[`cta_link${idx === 1 ? '' : idx}`]"
              :style="{
                color: hovered[idx] === 'a'
                  ? signpost[`cta_button${idx === 1 ? '' : idx}_hover_color`]
                  : signpost[`cta_button${idx === 1 ? '' : idx}_color`]
              }"
              tabindex="0"
              @mouseenter="hovered[idx] = 'a'"
              @mouseleave="hovered[idx] = null"
              @focus="hovered[idx] = 'a'"
              @blur="hovered[idx] = null"
            >{{ signpost[`cta_button${idx === 1 ? '' : idx}_name`] }}</a>
          </div>
        </a>
        <div v-else>
          <template v-if="signpost[`video${idx === 1 ? '' : idx}`]">
            <video-player
              class="signpost-video"
              :video="getVideoObject(idx)"
              :icon-color="signpost[`videoPlayerIconColor${idx === 1 ? '' : idx}`] || 'white'"
              is-autoplay
              :display-overlay="false"
              :cta-url="false"
              :use-overlay-button="false"
              width="260"
              height="215"
            />
          </template>
          <template v-else>
            <responsive-image
              class="responsive-image"
              :image="signpost[`image${idx === 1 ? '' : idx}`]"
              min-max="215-260"
              :ratio="false"
            />
          </template>
          <div
            v-if="!signpost.overlay_text"
            class="text-div"
            :class="getButtonPositionClass(idx)"
          >
            <p class="text-body-m-regular">
              {{ signpost[`image${idx === 1 ? '' : idx}_text`] }}
            </p>
            <a
              :class="`${$blockClass(blockClass, 'signpost-cta')} cta-button`"
              :href="signpost[`cta_link${idx === 1 ? '' : idx}`]"
            >{{ signpost[`cta_button${idx === 1 ? '' : idx}_name`] }}</a>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="signpost.product || signpost.product2 || signpost.product3"
      class="product-card-container"
    >
      <div
        v-if="signpost.product_title"
        class="product-info"
      >
        <div
          class="product-title text-other-label-bold text-type"
          :style="productTitleStyle"
        >
          {{ signpost.product_title }}
        </div>
      </div>

      <div class="product-navigation-card">
        <div
          v-if="signpost.product"
          class="product-info"
        >
          <a :href="signpost.product.url">
            <responsive-image
              :image="signpost.product.image"
              min-max="200-500"
              :ratio="false"
            />
          </a>
          <div class="product-card__footer text-center product-nav-card-footer">
            <h2 class="product-card__title text-other-label-bold">
              {{ signpost.product.title }}
            </h2>
            <product-prices
              class="product-card-container__prices"
              :compare-at-price="signpost.product.compare_at_price"
              :price="signpost.product.price"
              :show-discount="signpost.showDiscount"
            />
          </div>
        </div>

        <div
          v-if="signpost.product2"
          class="product-info"
        >
          <a :href="signpost.product2.url">
            <responsive-image
              :image="signpost.product2.image"
              min-max="200-500"
              :ratio="false"
            />
          </a>
          <div class="product-card__footer text-center product-nav-card-footer">
            <h2 class="product-card__title text-other-label-bold">
              {{ signpost.product2.title }}
            </h2>
            <product-prices
              class="product-card-container__prices"
              :compare-at-price="signpost.product2.compare_at_price"
              :price="signpost.product2.price"
              :show-discount="signpost.showDiscount"
            />
          </div>
        </div>

        <div
          v-if="signpost.product3"
          class="product-info"
        >
          <a :href="signpost.product3.url">
            <responsive-image
              :image="signpost.product3.image"
              min-max="200-500"
              :ratio="false"
            />
          </a>
          <div class="product-card__footer text-center product-nav-card-footer">
            <h2 class="product-card__title text-other-label-bold">
              {{ signpost.product3.title }}
            </h2>
            <product-prices
              class="product-card-container__prices"
              :compare-at-price="signpost.product3.compare_at_price"
              :price="signpost.product3.price"
              :show-discount="signpost.showDiscount"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Nav signpost (nav-signpost)
 * -----------------------------------------------------------------------------
 * Featured image and link for nav panel or drawer.
 * @param {Object} signpost - Featured image and link.
 * @param {String} [blockClass] - Block level class to apply to all elements.
 * @param {Boolean} isTabbable - Based on menu active state.
 */
import ResponsiveImage from '~global/images/responsive-image'
import VideoPlayer from '~async/video-player/video-player'
import ProductPrices from '~global/product-prices/product-prices'

export default {
  name: 'NavSignpost',

  components: {
    ResponsiveImage,
    VideoPlayer,
    ProductPrices,
  },

  props: {
    signpost: {
      type: Object,
      default: () => ({}),
    },
    blockClass: {
      type: String,
      default: '',
    },
    isTabbable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hovered: {},
    }
  },
  computed: {
    imageIndices() {
      return [1, 2, 3].filter(idx => this.signpost[`image${idx === 1 ? '' : idx}`] ||
        this.signpost[`video${idx === 1 ? '' : idx}`])
    },
    getButtonPositionClass() {
      return idx => {
        if (idx === 1) {
          return this.signpost.button_position === 'below' ? 'button-below' : 'button-side'
        }
        if (idx === 2) {
          return this.signpost.button2_position === 'below' ? 'button-below' : 'button-side'
        }
        if (idx === 3) {
          return this.signpost.button3_position === 'below' ? 'button-below' : 'button-side'
        }
        return ''
      }
    },
    productTitleStyle() {
      return {
        color: this.signpost.product_title_color,
      }
    },
    getOverlayPositionClass() {
      return idx => {
        if (!this.signpost.overlay_text) {
          return ''
        }
        let key = ''
        if (idx === 1) {
          key = 'overlay_text_position'
        } else if (idx === 2) {
          key = 'overlay_text_position2'
        } else {
          key = 'overlay_text_position3'
        }
        const pos = this.signpost[key] || 'bottom-left'
        return `signpost-overlay--${pos}`
      }
    },
  },
  methods: {
    getVideoObject(idx) {
      const videoData = this.signpost[`video${idx === 1 ? '' : idx}`]
      if (videoData && videoData.sources && Array.isArray(videoData.sources)) {
        const mp4Source = videoData.sources.find(src => src.format === 'mp4')
        if (mp4Source) {
          return {
            ...videoData,
            url: mp4Source.url,
            mimeType: 'video/mp4',
          }
        }
      }
      return null
    },
  },
}
</script>

<style lang="scss">
@import './nav-signpost';
</style>
